import type { NativeEventKind, NativeLabelKey, NativeRequest, NativeRequestEvent } from './types';

export const NATIVE_LABELS: Record<NativeLabelKey, string> = {
  with_team: 'With our team', waiting_on_you: 'Waiting on you', resolved: 'Resolved',
};

export const NATIVE_EVENT_LINES: Record<NativeEventKind, string> = {
  opened: 'Request opened', with_team: 'With our team', waiting_on_you: 'Waiting on you', resolved: 'Request resolved',
};

/** Unknown keys from another feed version stay absent; do not invent copy. */
export function nativeLabel(key: NativeLabelKey): string | null {
  return NATIVE_LABELS[key] ?? null;
}

export function nativeEventLine(kind: NativeEventKind): string | null {
  return NATIVE_EVENT_LINES[kind] ?? null;
}

export function nativeOpen(request: NativeRequest): boolean {
  return request.label_key !== 'resolved';
}

export function orderedNativeRequests(requests: NativeRequest[]): NativeRequest[] {
  return [...requests].sort((a, b) => Date.parse(b.latest_event_at) - Date.parse(a.latest_event_at) || a.id.localeCompare(b.id));
}

export function nativeSteps(request: NativeRequest, events: NativeRequestEvent[]) {
  const history = events.filter(e => e.request_id === request.id).sort((a, b) => Date.parse(a.at) - Date.parse(b.at) || a.id.localeCompare(b.id));
  return history.map((event, index) => ({
    kind: event.kind, label: nativeEventLine(event.kind), at: event.at,
    current: index === history.length - 1 && request.label_key === (event.kind === 'opened' ? 'with_team' : event.kind),
  }));
}
